import * as React from 'react';
import * as styles from './Page.css';

export interface IPageProps {
  children: React.ReactNode;
}

export function Page({ children }: IPageProps) {
  return <div className={styles['container']}>{children}</div>;
}
